import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { indexOf } from './mapList';
import FindCareResultsHeading from './FindCareResultsHeading';
import FilterItem from './FilterItem';
import PortalFilterPill from './PortalFilterPill';
import Spinner from '../common/spinner';
import Provider from "./Provider";
import Location from "./Location";
//import ServiceLocation from "./services/ServiceLocation";
import { getValue, availabilityList, genderList, translateText } from '../../helpers/data';
import { getDirectionsUrl } from "../../helpers/location";
import GoogleMapMain from "../common/googleMapMain";
import SelectedMapPinListing from "./SelectedMapPinListing";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import StaticHtmlContent from "../common/staticHtmlContent";
import { VIDEOVISIT_LABEL } from "../../constants/textConstants";
import Covid19VaccineProvider from '../covid19Vaccine/Covid19VaccineProvider';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Pagination from "react-js-pagination";
import { attachEvent } from '@microsoft/applicationinsights-core-js';
import { withTranslation } from 'react-i18next';
import { Accordion, Notifier, Typography } from '../ecosystem';

/*
 * Container component for the FindCare page.
 * 
 */
class FindCareResults extends React.Component {
    constructor(props, context) {
        super(props, context);

        const isVaccineSearch = window && window.location && window.location.pathname && window.location.pathname === "/findcare/vaccine" ? true : false;

        this.state = {
            selectedLocation: null,
            listView: true,
            filterCategoryOpen: '',
            indexOfFocus: 0,
            isVaccineSearch,
            activeLocationPage: 1,
            openNotifier: false,
        };

        this.myProviderRef = React.createRef();
        this.myLocationRef = React.createRef();
        this.hideInsuranceBanner = this.hideInsuranceBanner.bind(this);
    }

    componentDidMount() {
        const { scheduleCampaignReferrer } = this.props;
        let scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        logUI("MBHWeb.UI.FindCareResults.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity, this.state.isVaccineSearch ? 'isVaccineSearch' : '');
    }
    componentDidUpdate(prevProps, prevState) {
        const { locationsActivePage, locations, providers, isSearching } = this.props;
        if (locationsActivePage && prevProps.locationsActivePage !== locationsActivePage) {
            this.setState({ activeLocationPage: locationsActivePage })
        }
        if ((locations && locations.length >= 0 || providers && providers.length >= 0 || prevProps.searchKeyword !== this.props.searchKeyword) && isSearching && prevState.openNotifier) {
            this.setState({
                openNotifier: false
            })
        }
    
    }

    getDefaultDistance() {
        const { urgentCareModel } = this.props;
        if (urgentCareModel)
            return "10";
        else
            return "25";
    }

    resetFilterCategoryOpen() {
        this.setState({ filterCategoryOpen: '' });
    }

    setFilterCategory(category) {
        if (category === this.state.filterCategoryOpen)
            this.resetFilterCategoryOpen();
        else
            this.setState({ filterCategoryOpen: category });
    }

    toggleTabs(tab) {
        const { activeTab, mapList } = this.props;
        if (activeTab !== tab) {
            const indexOfFocus = tab === '1' ? indexOf(mapList, 'provider') : indexOf(mapList, 'location');
            this.setState({ indexOfFocus, selectedLocation: null });
            this.props.setActiveTab(tab);
        }
    }

    toggleFilters = () => {
        this.props.openFilters(!this.props.filtersOpen);
    }

    toggleAccordion = (e, index) => {
        if (this.state.openNotifier) {
            this.setState({
                openNotifier: false
            })
        } else {
            this.setState({
                openNotifier: true
            })
        }
        
    }
    setListView = (isListView) => {
        this.setState({ listView: isListView });
    }

    redirectToMap(item) {
        if (item.locationStreet1) {
            const toAddress = item.locationStreet1 + ', ' + item.locationCity + ', ' + item.locationState + ' ' + item.locationZip;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    handlePageClick(data) {
        // page number from the component is 0-based; service is 1-based
        if (this.myProviderRef) {
            this.myProviderRef.current.scrollTop = 0;
        }

        const { providerFilters, locationFilters } = this.props;
        const filters = { ...providerFilters, ...locationFilters };

        this.props.nextPage(data.selected + 1, filters);
    }

    toggleModal(location) {
        this.setState({ selectedLocation: location });
    }

    clearFilter(filter) {
        //Don't clear Video Visit filter if user clicked clear all button.
        if (filter && filter.value && typeof filter.value === 'string' && filter.value.toLowerCase() === VIDEOVISIT_LABEL) {
            return;
        }
        if (filter.type === 'radios') {
            filter.value = filter.defaultValue ? filter.defaultValue : '';
        }
        else if (filter.type === 'checkboxes') {
            filter.value = [];
        }
        else {
            filter.value = false;
        }
    }

    clearAllFilters(filters) {
        for (let i in filters) {
            this.clearFilter(filters[i]);
        }
    }

    clearFilters(searchType) {
        this.clearAllFilters(searchType !== 'location' ? this.props.providerFilters : this.props.locationFilters);
        this.applyFilters(searchType);
    }

    identifyIfMaxRadius(radius) {
        if (radius && radius === "250") {
            return true;
        } else {
            return false;
        }
    }

    removeFilter(item, searchType) {
        const filter = item.filter;
        if (filter.type === 'checkboxes') {
            const list = filter.value;
            const index = list.indexOf(item.display);
            if (index > -1) {
                list.splice(index, 1);
            }
        }
        else {
            this.clearFilter(item.filter);
        }
        this.applyFilters(searchType);
    }

    setProviderFilters(fields, values) {
        const { providerFilters } = this.props;

        for (let i = 0; i < fields.length; i++) {
            this.props.providerFilters[fields[i]].value = values[i];
        }
        if (providerFilters.isSpecialtyCare && providerFilters.isSpecialtyCare.value && providerFilters.isSpecialtyCare.value && fields && fields.length > 0 && fields[0] && fields[0].toLowerCase() === 'isspecialtycare') {
            providerFilters.isPrimaryCare.value = false;
        } else if (providerFilters.isPrimaryCare && providerFilters.isPrimaryCare.value && providerFilters.isPrimaryCare.value && fields && fields.length > 0 && fields[0] && fields[0].toLowerCase() === 'isprimarycare') {
            providerFilters.isSpecialtyCare.value = false;
        }
        this.applyFilters();
    }



    setLocationFilter(field, value) {
        this.props.locationFilters[field].value = value;
        this.applyFilters('location');
    }

    applyFilters(searchType) {
        const { providerFilters, locationFilters } = this.props;
        const filters = { ...providerFilters, ...locationFilters };
        this.props.applyFilters(filters, searchType);

        //this.setState({});
    }

    onSearchHere = (mappedArea) => {
        const { providerFilters, locationFilters } = this.props;
        const filters = { ...providerFilters, ...locationFilters };
        filters['distance'].value = mappedArea.distance;
        this.props.getMappedAreaSearchResults(filters, mappedArea);
    };

    hideInsuranceBanner() {
        this.setState({ [`fadeOut${this.props.activeTab}Banner`]: true });
    }

    setInsurancePlan = (appliedRules) => {
        const { hasAAL, userInsurancePlan } = this.props;
        // let defaultValue = userInsurancePlan;
        let defaultValue = hasAAL ? "Baylor Scott & White Quality Alliance" : userInsurancePlan;
        for (let i = 0; i < appliedRules.length; i++) {
            var key = appliedRules[i].split("=");
            if (key[0].toLowerCase() === "networkcode") {
                let insValue = key[1] ? key[1] : defaultValue;
                return insValue;
            }
        }
        return defaultValue;
    }

    updateToolTipPreference = () => {
        this.backdropClicked = true;
        const { updateVideoToolTipPreference } = this.props;
        if (updateVideoToolTipPreference)
            updateVideoToolTipPreference();
    }

    getSelected(filters) {
        const list = [];
        for (let key in filters) {
            const filter = filters[key];
            switch (filter.type) {
                case 'checkboxes':
                    filter.value.forEach(value => list.push({ filter, display: value }));
                    break;
                case 'radios':
                    if (typeof filter.value !== "undefined" && filter.value !== null && filter.value !== "" && filter.value !== -1 && filter.value !== 'Any') {
                        const value = filter.value;
                        const valueField = filter.valueField;
                        const displayField = filter.displayField;
                        if (valueField !== displayField) {
                            const options = filter.display;
                            for (let i = 0; i < options.length; i++) {
                                if (value === options[i][valueField]) {
                                    list.push({ filter, display: options[i][displayField] });
                                    break;
                                }
                            }
                        }
                        else {
                            list.push({ filter, display: value });
                        }
                    }
                    break;
                default:
                    if (filter.value === true) {
                        if (filter.type === 'portal') {
                            list.push({ filter, display: <PortalFilterPill /> });
                        }
                        else if (filter.display) {
                            list.push({ filter, display: filter.display });
                        }
                    }
                    break;
            }
        }
        return list;
    }

    handleLocationsPageChange = (pageNumber) => {
        if (this.myLocationRef) {
            this.myLocationRef.current.scrollTop = 0;
        }

        const { providerFilters, locationFilters } = this.props;
        const filters = { ...providerFilters, ...locationFilters };

        this.props.nextPageLocations(pageNumber, filters);
        this.setState({ activeLocationPage: pageNumber });
    }

    handlePageClickLocations(data) {
        // page number from the component is 0-based; service is 1-based
        if (this.myLocationRef) {
            this.myLocationRef.current.scrollTop = 0;
        }

        const { providerFilters, locationFilters } = this.props;
        const filters = { ...providerFilters, ...locationFilters };

        this.props.nextPageLocations(data.selected + 1, filters);
    }

    render() {
        const { providers, locations, totalProviders, totalLocations, pageSize, pageSizeLocations, activeTab, providerFilters, locationFilters, filtersOpen,
            networkCode, insurance, appliedRules, appliedRulesLoc, hasAAL, serverData, shouldShowVideoToolTip, searchRunning, updateVideoToolTipPreference,
            userInsurancePlan, searchParams, radius, smartResponseResults, onlineSchedulingEnabled, scheduleCampaignReferrer, t, translate, isMammogramSearch
        } = this.props;
        const { isVaccineSearch } = this.state;
        const NoFiltersMessage = 'No filters available';
        let selectedProvFiltersList = this.getSelected(providerFilters);
        let selectedProvFiltersCount = selectedProvFiltersList?.length ?? 0;
        let selectedLocFiltersList = this.getSelected(locationFilters);
        let selectedLocFiltersCount = selectedLocFiltersList?.length ?? 0;
        const hasProviderResults = providers && providers.length > 0;
        const hasLocationResults = locations && locations.length > 0;
        const totalPages = hasProviderResults ? Math.ceil(totalProviders / pageSize) : 0;
        const totalPagesLocations = hasLocationResults ? Math.ceil(totalLocations / pageSizeLocations) : 0;
        const hasAALOrSWHPInsurance = (networkCode && networkCode !== null && userInsurancePlan && insurance.toLowerCase() === userInsurancePlan.toLowerCase()) || (hasAAL && insurance.toLowerCase() === serverData.aaInsuranceCarrier.toLowerCase());
        const DIRECT_PRIMARY_CARE_NC = serverData && serverData.BSWDirectPrimaryCareNetworkCode ? serverData.BSWDirectPrimaryCareNetworkCode : "";
        const enableFindCareNewSearchTerms = serverData && serverData.enableFindCareNewSearchTerms ? serverData.enableFindCareNewSearchTerms : false;
        const enableV3SearchForAllProviders = serverData && serverData.enableV3SearchForAllProviders ? serverData.enableV3SearchForAllProviders : false;
        let insurancePlanName = '';
        let providersMarkup = [];
        let locationsMarkup = [];
        let isMaxSearchRadius = this.identifyIfMaxRadius(radius);
        const enableVaccineScheduling = serverData && serverData.enableCOVID19VaccineScheduling ? serverData.enableCOVID19VaccineScheduling : false;
        const { enableFindcareMammogramChanges } = window.serverData.data;
        if (activeTab === '1') {
            insurancePlanName = insurance && appliedRules && appliedRules.length > 0 ? this.setInsurancePlan(appliedRules) : hasAAL ? "Baylor Scott & White Quality Alliance" : userInsurancePlan;
        } else {
            insurancePlanName = insurance && appliedRulesLoc && appliedRulesLoc.length > 0 ? this.setInsurancePlan(appliedRulesLoc) : hasAAL ? "Baylor Scott & White Quality Alliance" : userInsurancePlan;
        }

        const safeCareMsg = serverData && serverData.safeCareMsg ? <StaticHtmlContent content={serverData.safeCareMsg} /> : '';
        const bannerMessages = [];
        if (!isVaccineSearch) {
            if (hasAALOrSWHPInsurance)
                bannerMessages.push(<StaticHtmlContent content={
                    translateText(translate, "You're off to a great start!", t) + " " + translateText(translate, "These", t) + " " +
                        (activeTab === '1' ? translateText(translate, "doctors", t) : translateText(translate, "locations", t)) + " " + translateText(translate, "accept", t) + " " +
                        translateText(translate, "your", t) + " " + translateText(translate, insurancePlanName, t) + "."
                } classname="insurance-banner-msg" />);
            if (networkCode === DIRECT_PRIMARY_CARE_NC)
                bannerMessages.push(<StaticHtmlContent content={translateText(translate, "Members with the direct primary care benefit can make or change their PCP selection through the ", t) +
                    ' <a href="https://mydpc.accresa.com/#/" target="_blank">Accresa ' + translateText(translate, "portal", t) + '</a>'} />);
            if (serverData && serverData.covidVideoSchedulingEnabled === true)
                bannerMessages.push(translateText(translate, "For your safety, due to COVID-19 most doctors are offering virtual visits.", t));
            if (safeCareMsg)
                bannerMessages.push(safeCareMsg);
        } else if (isVaccineSearch) {
            bannerMessages.push(translateText(translate, "Select a time frame and we'll schedule an appointment within that time for you.", t));
        }

        const insuranceBanner =
            (<div className={"row insurance-banner" + (!this.state[`fadeOut${activeTab}Banner`] ? ' fadeIn' : ' fadeOut')}>
                <div className="col-12 align-self-center">
                    <div className="insurance-banner-content">
                        {bannerMessages.map((msg, i) => { return <React.Fragment key={i}>{msg}</React.Fragment>; })}
                        <span className="icon-close" onClick={this.hideInsuranceBanner} />
                    </div>
                </div>
            </div>);
        if (providers && providers.length > 0) {

            providersMarkup = providers.map((prov, i) => {
                return isVaccineSearch ?
                    <Covid19VaccineProvider xid={searchParams && searchParams.xid ? searchParams.xid : ""} providerData={prov.provider} visitType={providerFilters.visitType} redirectToMap={this.redirectToMap} key={i} searchModel={this.props.searchModel} isVaccineSearch={isVaccineSearch} showProviderDetails />
                    : <Provider providerData={prov.provider}
                        buttonText={translateText(translate, !enableV3SearchForAllProviders ? "More" : "Book Now", t)}
                        visitType={providerFilters.visitType}
                        redirectToMap={this.redirectToMap}
                        key={i}
                        searchModel={this.props.searchModel}
                        isVaccineSearch={isVaccineSearch}
                        onlineSchedulingEnabled={onlineSchedulingEnabled}
                        showProviderDetails
                        scheduleCampaignReferrer={scheduleCampaignReferrer}
                        translate={translate}
                        t={t}
                    />;
            });
        }

        if (locations && locations.length > 0) {
            locationsMarkup = locations.map((loc, i) => (
                <Location locationData={loc} redirectToMap={this.redirectToMap} key={i} selectedIndex={i} appliedRulesLoc={appliedRulesLoc}
                    serverData={serverData}
                    buttonText={loc.openSchedules && loc.openSchedules.dateAndTimes && loc.openSchedules.dateAndTimes.times && loc.openSchedules.dateAndTimes.times.length > 0
                        ? translateText(translate, "More", t) : translateText(translate, "Book Now", t)
                    }
                    scheduleCampaignReferrer={scheduleCampaignReferrer} totalLocations={totalLocations} translate={translate} t={t}
                />
            ));
        }

        const visitTypesWithoutVideoVisit = { ...providerFilters.visitType };
        if (providerFilters && providerFilters.visitType && providerFilters.visitType.display && providerFilters.visitType.display.length > 0) {
            visitTypesWithoutVideoVisit.display = providerFilters.visitType.display.filter((item) => item.key.toLowerCase() !== VIDEOVISIT_LABEL);
        }

        if (enableFindCareNewSearchTerms) { (activeTab === '2'); }

        const miles = translateText(translate, "miles", t);
        const within = translateText(translate, "within", t);
        const unableToFind = translateText(translate, "Unable to find", t);
        const results = translateText(translate, "results", t);
        const matchSearchCriteria = translateText(translate, "that match your search criteria.", t);
        const checkSpellingOrModifySearch = translateText(translate, "Try checking the spelling or modify your search.", t);

        return (
            <div className={"row find-care-results " + (this.state.listView ? " list-view" : " map-view") + (filtersOpen ? " filter-open-view" : "")}>
                <div className="col-12">
                    <Nav tabs>
                        <NavItem>
                            <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => this.toggleTabs('1')}>
                                {translateText(translate, "Doctors", t)} ({this.props.searchRunning ? '...' : (totalProviders ? totalProviders : '0')})
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => this.toggleTabs('2')}>
                                {translateText(translate, "Locations", t)} ({this.props.searchLocationsRunning ? '...' : (totalLocations ? totalLocations : '0')})
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1" className="doctor-results">
                            <div className="row filters-container">
                                <div className="col-12 filters-content">
                                    <FindCareResultsHeading listName="Doctors" resultsCount={totalProviders} filtersList={providerFilters}
                                        selectedFiltersList={selectedProvFiltersList}
                                        selectedFiltersCount={selectedProvFiltersCount}
                                        toggleFilters={this.toggleFilters} toggleView={this.setListView}
                                        onFilterRemove={item => this.removeFilter(item)} onFiltersClear={() => this.clearFilters('provider')}
                                        onFilterSet={(filter, value) => this.setProviderFilters(filter, value)}
                                        updateVideoToolTipPreference={updateVideoToolTipPreference} shouldShowVideoToolTip={shouldShowVideoToolTip}
                                        searchRunning={searchRunning}
                                        translate={translate}
                                    />

                                    {/*Available Physician Filters*/}
                                    <div className="row filter-options-list">
                                        {onlineSchedulingEnabled && <>
                                            {/*<div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-onlineBooking' ? " filter-col-open" : "")} role="radiogroup" aria-labelledby="vType">
                                                <div className="filter-heading" id="vType" onClick={() => { this.setFilterCategory('dr-onlineBooking'); }}>
                                                    Online Booking Appointment Type <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                                </div>
                                                <div className="filter-options">
                                                    <ul>
                                                        <FilterItem item={{ value: "visitType", display: "No Preference", type: "radio" }} name="visitType"
                                                            checked={providerFilters.visitType.value === -1} onChange={checked => { if (checked) this.setProviderFilters(['visitType'], [-1]); }}
                                                        />
                                                        <FilterItem item={visitTypesWithoutVideoVisit} valueField="key" displayField="key" name="visitType"
                                                            onChange={(checked, value) => this.setProviderFilters(['visitType'], [checked ? value : -1])}
                                                        />
                                                    </ul>
                                                </div>
                                            </div>*/}
                                            <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-availability' ? " filter-col-open" : "")} role="radiogroup" aria-labelledby="availability">
                                                <div className="filter-heading" id="availability" onClick={() => { this.setFilterCategory('dr-availability'); }}>
                                                    Online Booking Availability <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                                </div>
                                                <div className="filter-options">
                                                    {(providerFilters.availability && providerFilters.availability.display.length > 0) ?
                                                        <ul>
                                                            <FilterItem item={providerFilters.availability} valueField="value" displayField="display" name="availability"
                                                                onChange={(checked, value) => this.setProviderFilters(['availability'], [checked ? value : -1])} t={t} translate={translate}
                                                            />
                                                        </ul>
                                                        : NoFiltersMessage
                                                    }
                                                </div>
                                            </div>
                                        </>}
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-perks' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('dr-perks'); }}>
                                                Patient Perks <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {(providerFilters.usesMyBSWHealth && providerFilters.usesMyBSWHealth.display.length > 0) ||
                                                    (providerFilters.openScheduling && providerFilters.openScheduling.display && providerFilters.openScheduling.display.length > 0) ||
                                                    (providerFilters.acceptingNewPatient && providerFilters.acceptingNewPatient.display.length > 0) ?
                                                    <ul>
                                                        <FilterItem item={providerFilters.usesMyBSWHealth}
                                                            onChange={checked => this.setProviderFilters(['usesMyBSWHealth', 'usesMyBSWHealthAppliedFilter'], [checked, false])}
                                                        />
                                                        {onlineSchedulingEnabled && < FilterItem item={providerFilters.openScheduling}
                                                            onChange={checked => this.setProviderFilters(['openScheduling'], [checked])}
                                                        />}
                                                        <FilterItem item={providerFilters.acceptingNewPatient}
                                                            onChange={checked => this.setProviderFilters(['acceptingNewPatient'], [checked])}
                                                        />
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-specialty' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('dr-specialty'); }}>
                                                Specialty <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {(providerFilters.isPrimaryCare && providerFilters.isPrimaryCare.display.length > 0) ||
                                                    (providerFilters.isSpecialtyCare && providerFilters.isSpecialtyCare.display.length > 0) ||
                                                    (providerFilters.specialties && providerFilters.specialties.display.length > 0) ?
                                                    <ul>
                                                        <FilterItem item={providerFilters.isPrimaryCare}
                                                            onChange={checked => this.setProviderFilters(['isPrimaryCare', 'isPrimaryCareAppliedFilter'], [checked, false])}
                                                        />
                                                        <FilterItem item={providerFilters.isSpecialtyCare}
                                                            onChange={checked => this.setProviderFilters(['isSpecialtyCare', 'isSpecialtyCareAppliedFilter'], [checked, false])}
                                                        />
                                                        {providerFilters.specialties && providerFilters.specialties &&
                                                            <div>
                                                                <li><div className="filter-divider" /></li>
                                                                <FilterItem item={providerFilters.specialties} displayField='key'
                                                                    onChange={checked => this.setProviderFilters(['specialties'], [checked, false])}
                                                                />
                                                            </div>
                                                        }
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                                <div><div className="filter-included hidden">Included in Search</div></div>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-gender' ? " filter-col-open" : "")} role="radiogroup" aria-labelledby="dGender">
                                            <div className="filter-heading" id="dGender" onClick={() => { this.setFilterCategory('dr-gender'); }}>
                                                Doctor's Gender <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {(providerFilters.gender && providerFilters.gender.display.length > 0) ?
                                                    <ul>
                                                        <FilterItem item={providerFilters.gender} valueField="value" displayField="value" name="gender"
                                                            onChange={(checked, value) => this.setProviderFilters(['gender'], [checked ? value : 'Any'])}
                                                        />
                                                    </ul>
                                                    : filterStatus
                                                }
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-age' ? " filter-col-open" : "")} role="radiogroup" aria-labelledby="ageGroup">
                                            <div className="filter-heading" id="ageGroup" onClick={() => { this.setFilterCategory('dr-age'); }}>
                                                Age Group Seen <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                <ul>
                                                    <FilterItem item={{ value: "", display: "No Preference", type: "radio" }} name="ageGroup"
                                                        checked={providerFilters.ageGroupsSeen.value === ""} onChange={checked => { if (checked) this.setProviderFilters(['ageGroupsSeen'], ['']); }}
                                                    />
                                                    <FilterItem item={providerFilters.ageGroupsSeen} valueField="key" displayField="key" name="ageGroup"
                                                        onChange={(checked, value) => this.setProviderFilters(['ageGroupsSeen'], [checked ? value : ''])}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'dr-language' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('dr-language'); }}>
                                                Languages Spoken <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {(providerFilters.languages && providerFilters.languages.display.length > 0) ?
                                                    <ul>
                                                        <FilterItem item={providerFilters.languages} displayField="key"
                                                            onChange={(value) => this.setProviderFilters(['languages'], [value])}
                                                        />
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*Physicians Listing*/}
                            <div className="row">
                                <div className="col-12 col-md-7 results-list-container">
                                    {this.state.selectedLocation &&
                                        <SelectedMapPinListing
                                            buttonText={translateText(translate, !enableV3SearchForAllProviders ? "More" : "Book Now", t)}
                                            selectedLocation={this.state.selectedLocation}
                                            tabIndex={this.props.activeTab}
                                            appliedRulesLoc={appliedRulesLoc}
                                            toggleOverlay={() => this.toggleModal(null)}
                                            isOpen={this.state.selectedLocation}
                                            isVaccineSearch={isVaccineSearch}
                                            onlineSchedulingEnabled={onlineSchedulingEnabled}
                                            translate={translate}
                                            t={t}
                                        />
                                    }
                                    <div className="row">
                                        <div ref={this.myProviderRef} className="col-12 results-list-scrollable">
                                            <div className="list-options-row">

                                                <div className="sort-container">
                                                    {hasProviderResults && <> {translateText(translate, "Sort By", t)}:
                                                        <select id="sortBy_fcResult" value={providerFilters.sortBy.value} onChange={(e) => this.setProviderFilters(['sortBy'], [e.target.value])} aria-label="Sort by">
                                                            <option value="NextAvailableAppointment">{translateText(translate, "Next Available Appointment", t)}</option>
                                                            {this.props.canSelectDistance &&
                                                                <option value="Distance">{translateText(translate, "Distance", t)}</option>
                                                            }
                                                            <option value="ProviderNameAsc">{translateText(translate, "Ascending", t)} A-Z</option>
                                                            <option value="ProviderNameDesc">{translateText(translate, "Descending", t)} Z-A</option>
                                                        </select>
                                                    </>
                                                    }
                                                </div>
                                                {this.props.canSelectDistance &&
                                                    <div className="miles-container">
                                                        <select id="selMiles_fcResult" value={this.props.radius ? this.props.radius : providerFilters.distance.value}
                                                            onChange={(e) => {
                                                                this.props.resetRadius(e.target.value); this.setProviderFilters(['distance'], [e.target.value]);
                                                                isMaxSearchRadius = this.identifyIfMaxRadius(e.target.value);
                                                            }}
                                                            aria-label="Radius"
                                                        >
                                                            {this.props.isMappedArea &&
                                                                <option value={"Radius"} disabled>{translateText(translate, "Radius", t)}</option>
                                                            }
                                                            <option value="5">5 {miles}</option>
                                                            <option value="10">10 {miles}</option>
                                                            <option value="25">25 {miles}</option>
                                                            <option value="50">50 {miles}</option>
                                                            <option value="100">100 {miles}</option>
                                                            <option value="250">250 {miles}</option>
                                                        </select>
                                                    </div>
                                                }
                                            </div>
                                            {hasProviderResults && !this.props.searchRunning && bannerMessages.length > 0 && insuranceBanner}
                                            <div className="row find-care-list">
                                                {
                                                    providersMarkup
                                                }
                                                {
                                                    !hasProviderResults && !this.props.searchRunning && !isVaccineSearch &&
                                                    <div className="col-12 no-results-container">
                                                        <div className="msg-heading">
                                                            {unableToFind} {hasLocationResults && <span>{translateText(translate, "doctor", t)}</span>} {results}
                                                            {this.props.radius
                                                                ? this.props.radius === "Radius" ? "" : ` ${within} ${this.props.radius} ${miles}`
                                                                : ` ${within} ${providerFilters.distance.value} ${miles}`
                                                            }{matchSearchCriteria}
                                                        </div>
                                                        <div className="msg-content">
                                                            {smartResponseResults && selectedProvFiltersCount < 1 ?
                                                                <>
                                                                    {smartResponseResults.message + " "}
                                                                    <button className="btn text-btn" onClick={() => { this.props.searchProvidersAndLocations(true, true) }}>Show Me</button>
                                                                </>
                                                                : checkSpellingOrModifySearch
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    (!enableVaccineScheduling || !hasProviderResults) && !this.props.searchRunning && isVaccineSearch && isMaxSearchRadius &&
                                                    <div className="col-12 no-results-container">
                                                        <div className="msg-heading"></div>
                                                        <div className="msg-content-covid">
                                                            {serverData.covid19VaccineSearchNoResultsMax
                                                                ? <StaticHtmlContent content={serverData.covid19VaccineSearchNoResultsMax} />
                                                                : <>Unfortunately, we do not have the supply at this time to accommodate vaccination appointments within this search area. &nbsp;&nbsp;
                                                                    Please check back in the coming days, as appointments will be opened on an ongoing basis as supply becomes available.<br /><br />
                                                                    We are thankful to be your partner in health.&nbsp;&nbsp;
                                                                    Together, we can continue to navigate the uncertainties of this pandemic and protect our communities.
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    (!enableVaccineScheduling || !hasProviderResults) && !this.props.searchRunning && isVaccineSearch && !isMaxSearchRadius &&
                                                    <div className="col-12 no-results-container">
                                                        <div className="msg-heading"></div>
                                                        <div className="msg-content-covid">
                                                            {serverData.covid19VaccineSearchNoResults
                                                                ? <StaticHtmlContent content={serverData.covid19VaccineSearchNoResults} />
                                                                : <>Unfortunately, we do not have the supply at this time to accommodate vaccination appointments within this search area. &nbsp;&nbsp;
                                                                    Please expand your search area or check back in the coming days, as appointments will be opened on an ongoing basis as supply becomes available.<br /><br />
                                                                    We are thankful to be your partner in health.&nbsp;&nbsp;
                                                                    Together, we can continue to navigate the uncertainties of this pandemic and protect our communities.
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    this.props.searchSucceeded && hasProviderResults && this.props.providersLoading === false &&
                                                    <div className="col-12 provider-search-legal">
                                                        <div className="legal-statement">
                                                            <sup>*</sup> Patient rating scores are based on the <a href="http://www.bswhealth.com/physicians/about-press-ganey-satisfaction-survey" target="_blank">Press Ganey Patient Satisfaction Survey</a>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    (this.props.providersLoading === true) &&
                                                    <Spinner />
                                                }
                                            </div>
                                            {
                                                totalPages > 1 &&
                                                <div className="row find-care-pagination">
                                                    <div className="col-12">
                                                        <ReactPaginate
                                                            previousLabel={'<'}
                                                            nextLabel={'>'}
                                                            breakLabel={'...'}
                                                            breakClassName={'break-me'}
                                                            pageCount={totalPages}
                                                            marginPagesDisplayed={2}
                                                            hideFirstLastPages={false}
                                                            pageRangeDisplayed={5}
                                                            onPageChange={(data) => this.handlePageClick(data)}
                                                            containerClassName={'pagination'}
                                                            subContainerClassName={'pages pagination'}
                                                            activeClassName={'active'}
                                                            nextLinkClassName={'next-arrow'}
                                                            previousLinkClassName={'prev-arrow'}
                                                            forcePage={this.props.providersActivePage - 1}
                                                        />

                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {isVaccineSearch &&
                                        <div className={"row" + (hasProviderResults ? "" : " show-result-border")}>
                                            <div className="col-12 all-covid19-vaccine-providers">
                                                <div className="icon-col">
                                                    <span className="icon-address"></span>
                                                </div>
                                                <div className="all-details-col">
                                                    <span className="note">NOTE:</span>
                                                    {serverData.Covid19VaccineAllProviders ? <StaticHtmlContent content={serverData.Covid19VaccineAllProviders} /> :
                                                        <>Only locations with current vaccine availability will display. Availability will be updated weekly. View a list of Baylor Scott &amp; White active vaccine providers &lt;a href='https://www.bswhealth.com/covid-vaccine#vaccine-hubs' target='_blank' &gt;here&lt;/a&gt;.</>}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>

                            </div>
                        </TabPane>

                        <TabPane tabId="2" className="location-results">
                            <div className="row filters-container">
                                <div className="col-12 filters-content">
                                    <FindCareResultsHeading listName="Locations" resultsCount={totalLocations} filtersList={locationFilters}
                                        selectedFiltersList={selectedLocFiltersList}
                                        selectedFiltersCount={selectedLocFiltersCount}
                                        appliedRules={appliedRules}
                                        toggleFilters={this.toggleFilters} toggleView={this.setListView}
                                        onFilterRemove={item => this.removeFilter(item, 'location')} onFiltersClear={() => this.clearFilters('location')}
                                        isDisabled={enableFindcareMammogramChanges && enableFindCareNewSearchTerms && appliedRules && appliedRules.length && (appliedRules[0].toLowerCase() == "keyword=mammography" || appliedRules[0].toLowerCase() == "keyword=mammogram" || appliedRules[0].toLowerCase() == "keyword=screening mammogram")}
                                        //isDisabled = {false}
                                        translate={translate}
                                    />
                                    {/*Available Location Filters*/}
                                    <div className="row filter-options-list">
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'loc-perks' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('loc-perks'); }}>
                                                Patient Perks <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {locationFilters.locationPerks && locationFilters.locationPerks.display && locationFilters.locationPerks.display.length > 0 ?
                                                    <ul>
                                                        <FilterItem item={locationFilters.locationPerks} displayField="value"
                                                            onChange={(value) => this.setLocationFilter('locationPerks', value)}
                                                        />
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'loc-services' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('loc-services'); }}>
                                                Services and Equipment <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>

                                            <div className="filter-options">
                                                {locationFilters.locationServices && locationFilters.locationServices.display && locationFilters.locationServices.display.length > 0 ?
                                                    <ul>
                                                        <FilterItem item={locationFilters.locationServices} displayField="value"
                                                            onChange={(value) => this.setLocationFilter('locationServices', value)}
                                                        />
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>

                                        </div>
                                        {/*
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'loc-specialty' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('loc-specialty'); }}>
                                                Specialty <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                <ul>
                                                    <li>
                                                        <label className="checkbox-container">
                                                            <input type="checkbox" name="PrimaryCare" checked={this.state.isPrimaryCare} onChange={(e) => this.setLocationFilter('isPrimaryCare', e.target.checked })} />
                                                            <span className="checkmark" />
                                                            <span className="filter-name">Primary Care</span>
                                                        </label>
                                                    </li>
                                                    
                                                        <li>
                                                            <label className="checkbox-container">
                                                                <input type="checkbox" name="Specialty" checked={this.state.isSpecialtyCare} onChange={(e) => this.setLocationFilter('isSpecialtyCare', e.target.checked })} />
                                                                <span className="checkmark" />
                                                                <span className="filter-name">Specialty</span>
                                                            </label>
                                                        </li>
                                                        <li><div className="filter-divider" /></li>
                                                        
                                                    {this.props.locationSpecialtyFacet && this.props.locationSpecialtyFacet.map((spec, i) =>
                                                        <li key={i}>
                                                            <label className="checkbox-container">
                                                                <input type="checkbox" name="Specialty" checked={this.state.locationSpecialties.indexOf(spec.value) >= 0} onChange={(e) => this.updateList('locationSpecialties', spec.value, e.target.checked)} />
                                                                <span className="checkmark" />
                                                                <span className="filter-name">{spec.value}</span>
                                                            </label>
                                                        </li>
                                                    )}
                                                </ul>
                                                <div>
                                                    <div className="filter-included hidden">Included in Search</div>
                                                </div>
                                            </div>
                                        </div>
                                        */
                                        }
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'loc-type' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('loc-type'); }}>
                                                Location Type <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {locationFilters.locationTypes && locationFilters.locationTypes && locationFilters.locationTypes.display && locationFilters.locationTypes.display.length > 0 ?
                                                    <ul>
                                                        <FilterItem item={locationFilters.locationTypes} displayField="value"
                                                            onChange={(value) => this.setLocationFilter('locationTypes', value)}
                                                        />

                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>
                                        </div>
                                        <div className={"col-12 col-sm filter-col" + (this.state.filterCategoryOpen === 'loc-hours' ? " filter-col-open" : "")}>
                                            <div className="filter-heading" onClick={() => { this.setFilterCategory('loc-hours'); }}>
                                                Hours <span className="float-right icon-dd" /><span className="float-right icon-dd-up" />
                                            </div>
                                            <div className="filter-options">
                                                {(locationFilters.locationOpenNow && locationFilters.locationOpenNow.display && locationFilters.locationOpenNow.display.length > 0) ||
                                                    (locationFilters.locationOpenBefore8 && locationFilters.locationOpenBefore8.display && locationFilters.locationOpenBefore8.display.length > 0) ||
                                                    (locationFilters.locationOpenAfter5 && locationFilters.locationOpenAfter5.display && locationFilters.locationOpenAfter5.display.length > 0) ||
                                                    (locationFilters.locationOpenWeekends && locationFilters.locationOpenWeekends.display && locationFilters.locationOpenWeekends.display.length > 0) ?
                                                    <ul>
                                                        {[
                                                            { field: 'locationOpenNow', item: locationFilters.locationOpenNow }, { field: 'locationOpenBefore8', item: locationFilters.locationOpenBefore8 },
                                                            { field: 'locationOpenAfter5', item: locationFilters.locationOpenAfter5 }, { field: 'locationOpenWeekends', item: locationFilters.locationOpenWeekends }
                                                        ].map((loc, index) =>
                                                            <FilterItem key={index} item={loc.item}
                                                                onChange={checked => this.setLocationFilter(loc.field, checked)}
                                                            />
                                                        )}
                                                    </ul>
                                                    : NoFiltersMessage
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*Locations Listing*/}
                            <div className="row">
                                <div className="col-12 col-md-7 results-list-container">
                                    {this.state.selectedLocation &&
                                        <SelectedMapPinListing
                                            buttonText={translateText(translate, !enableV3SearchForAllProviders ? "More" : "Book Now", t)}
                                            selectedLocation={this.state.selectedLocation}
                                            tabIndex={this.props.activeTab}
                                            appliedRulesLoc={appliedRulesLoc}
                                            toggleOverlay={() => this.toggleModal(null)}
                                            isOpen={this.state.selectedLocation}
                                            onlineSchedulingEnabled={onlineSchedulingEnabled}
                                            translate={translate}
                                            t={t}
                                        />
                                    }
                                    <div className="row">
                                        <div ref={this.myLocationRef} className="col-12 results-list-scrollable">

                                            <div className="list-options-row">
                                                <div className="sort-container">
                                                    {hasLocationResults && <> {translateText(translate, "Sort By", t)}:
                                                        <select id="sortBy_location_fcResult" value={locationFilters.locationSortBy.value} onChange={e => this.setLocationFilter('locationSortBy', e.target.value)} aria-label="Sort by">
                                                            {this.props.canSelectDistance && <option value="Distance">{translateText(translate, "Distance", t)}</option>}
                                                            {enableFindCareNewSearchTerms ? <option value="NextAvailableAppointment">{translateText(translate, "Next Available Appointment", t)}</option> : ""}
                                                            <option value="LocationNameAsc">{translateText(translate, "Alphabetical Ascending", t)} A-Z</option>
                                                            <option value="LocationNameDesc">{translateText(translate, "Alphabetical Descending", t)} Z-A</option>
                                                        </select>
                                                    </>
                                                    }
                                                </div>
                                                {this.props.canSelectDistance &&
                                                    <div className="miles-container">
                                                        <select id="selMiles_location_fcResults" value={this.props.radius ? this.props.radius : providerFilters.distance.value}
                                                            onChange={e => { this.props.resetRadius(e.target.value); this.setProviderFilters(['distance'], [e.target.value]); }}
                                                            aria-label="Radius"
                                                        >
                                                            {this.props.isMappedArea &&
                                                                <option value={"Radius"} disabled>{translateText(translate, "Radius", t)}</option>
                                                            }
                                                            <option value="5">5 {miles}</option>
                                                            <option value="10">10 {miles}</option>
                                                            <option value="25">25 {miles}</option>
                                                            <option value="50">50 {miles}</option>
                                                            <option value="100">100 {miles}</option>
                                                            <option value="250">250 {miles}</option>
                                                        </select>
                                                    </div>
                                                }
                                            </div>
                                            {hasLocationResults && !this.props.searchLocationsRunning && bannerMessages.length > 0 && insuranceBanner}
                                            <div className="row find-care-list">

                                                {isMammogramSearch && hasLocationResults && this.state.activeLocationPage === 1 && 
                                                    <div className="col-12 find-care-notification-container">
                                                        
                                                        <Notifier
                                                            accordion={{
                                                                open: this.state.openNotifier,
                                                                toggle: () => this.toggleAccordion()
                                                            }}
                                                            heading={<Typography type="body-01" color="$color-primary-a2"> {translateText(translate, "mammoNotifierTitle", t)} </Typography>}
                                                            icon="alert"
                                                        >
                                                            <Typography type="body-01" color="$color-primary-a2">
                                                                <p>{translateText(translate, "twoDimensionalMammoDescription", t)} </p>
                                                                    < p > {translateText(translate, "threeDimensionalMammoDescription" ,t)}</p>
                                                            </Typography>
                                                        </Notifier>
                                                    </div>
                                                }
                                                {
                                                    locationsMarkup
                                                }
                                                {
                                                    !hasLocationResults && !this.props.searchLocationsRunning &&
                                                    <div className="col-12 no-results-container">
                                                        <div className="msg-heading">
                                                            {unableToFind} {hasProviderResults}{' '}
                                                            <span>{translateText(translate, "location", t)}</span>
                                                            {' '}{results}{' '}{this.props.radius
                                                                ? this.props.radius === "Radius" ? "" : ` ${within} ${this.props.radius} ${miles}`
                                                                : `${within} ${providerFilters.distance.value}  ${miles} ${matchSearchCriteria}`}
                                                        </div>
                                                        <div className="msg-content">{checkSpellingOrModifySearch}</div>
                                                    </div>
                                                }
                                                {
                                                    (this.props.locationsLoading === true) &&
                                                    <Spinner />
                                                }
                                            </div>
                                            {
                                                totalPagesLocations > 1 &&
                                                <div className="row find-care-pagination">
                                                    <div className="col-12">
                                                        {(enableFindCareNewSearchTerms) ?
                                                            <Pagination
                                                                activePage={this.state.activeLocationPage}
                                                                itemsCountPerPage={12}
                                                                firstPageText={translateText(translate, "FIRST", t)}
                                                                lastPageText={translateText(translate, "LAST", t)}
                                                                linkClassFirst={'first-arrow'}
                                                                linkClassLast={'last-arrow'}
                                                                itemClassFirst={'first-arrow'}
                                                                itemClassLast={'last-arrow'}
                                                                activeClass="active"
                                                                innerClass={'pagination'}
                                                                hideNavigation={true}
                                                                totalItemsCount={totalPagesLocations * 12}
                                                                pageRangeDisplayed={5}
                                                                onChange={this.handleLocationsPageChange.bind(this)}
                                                            /> :
                                                            <ReactPaginate
                                                                previousLabel={'<'}
                                                                nextLabel={'>'}
                                                                breakLabel={'...'}
                                                                breakClassName={'break-me'}
                                                                pageCount={totalPagesLocations}
                                                                marginPagesDisplayed={2}
                                                                pageRangeDisplayed={5}
                                                                onPageChange={(data) => this.handlePageClickLocations(data)}
                                                                containerClassName={'pagination'}
                                                                subContainerClassName={'pages pagination'}
                                                                activeClassName={'active'}
                                                                nextLinkClassName={'next-arrow'}
                                                                previousLinkClassName={'prev-arrow'}
                                                                forcePage={this.props.locationsActivePage - 1}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </TabPane>

                        <div className="find-care-map">
                            <div className="find-care-google-map">
                                <GoogleMapMain
                                    list={this.state.indexOfFocus !== null ? this.props.mapList : []}
                                    getLatitude={item => item.latitude}
                                    getLongitude={item => item.longitude}
                                    getId={item => item.key}
                                    getDisplayValue={item => item.group.length === 1 ? item.name : `${item.group.length} relevant results`}
                                    highlightSelectedItem={this.state.selectedLocation !== null}
                                    indexOfFocus={this.state.indexOfFocus}
                                    onItemSelected={item => this.toggleModal(item)}
                                    onItemDeselected={() => this.toggleModal(null)}
                                    searchHereButton
                                    getMappedAreaSearchResults={this.onSearchHere}
                                    isMappedArea={this.props.isMappedArea}
                                    fitBounds={this.props.fitBounds}
                                    setFitBounds={this.props.setFitBounds}
                                    distance={providerFilters.distance.value}
                                    filtersOpen={this.props.filtersOpen}
                                    radius={this.props.radius}
                                    hideSearchHere={this.props.hideSearchHere}
                                    setMainSearch={(value) => (this.props.setMainSearch(value))}
                                    isVaccineSearch={isVaccineSearch}
                                    translate={translate}
                                    t={t}
                                />
                            </div>
                        </div>

                    </TabContent>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const provSearchModel = state.providers.searchModel ? state.providers.searchModel : {};
    const locSearchModel = state.locations.searchModel ? state.locations.searchModel : {};
    const urgentCareModel = ownProps.urgentCareModel; //TODO, need to remove this once everything is confirmed about appliedRules for urgent care.
    const searchParams = ownProps.searchParams;
    const appliedRules = state.providers.appliedRules;
    const appliedRulesLoc = state.locations.appliedRules;
    const isUrgentCare = appliedRules && appliedRules.indexOf('SOPTerms.UrgentCare') > -1 && ownProps.overrideRules === false;
    const usesMyBSWHealthAppliedFilter = (appliedRules && appliedRules.indexOf('UsesMyBSWHealth') > -1) ? true : false; //its always applied by default
    const isPrimaryCareAppliedFilter = appliedRules && appliedRules.indexOf('IsPrimaryCare') > -1 ? true : false;
    const isSpecialtyCareAppliedFilter = !isUrgentCare && appliedRules && appliedRules.indexOf('IsSpecialtyCare') > -1;//its not part of urgent care appliedRules, not sure when we get this case in appliedRules.
    const specialtyFacet = state.providers.specialties
    const urgentCareAvailability = (isUrgentCare && appliedRules && appliedRules.indexOf('OnlineBookingAvailability.Next3Days') > -1) ? 3 : -1;
    const urgentCareBookOnline = (isUrgentCare && appliedRules && appliedRules.indexOf('Perks.BookOnline') > -1) ? true : false;
    const urgentCarePerksWalkins = (isUrgentCare && appliedRulesLoc && appliedRulesLoc.indexOf('Perks.Walk-Ins') > -1) ? ["Accepts Walk-ins"] : [];
    let urgentCareDistance = false;
    let urgentCareDistanceValue = '';
    if (isUrgentCare && appliedRules) {
        appliedRules.forEach(function (value, index) {
            if (typeof value === 'string' && value.toLowerCase().indexOf('distance') > -1) {
                urgentCareDistance = true;
                let disValue = value.split('.');
                urgentCareDistanceValue = disValue.length > 1 ? disValue[1] : '';
            }
        });
    }
    const urgentCareSortByNextAvailableAppointment = isUrgentCare && appliedRules && appliedRules.indexOf('SortBy.NextAvailableAppointment') > -1;
    return {
        hasAAL: !state.common.aalDown && state.memberships.hasAA,
        serverData: state.session.serverData,
        totalProviders: state.providers.totalProviders,
        totalLocations: state.locations.totalLocations,
        providers: state.providers.providers,
        smartResponseResults: state.providers.smartResponseResults,
        locations: state.locations.locations,
        searchRunning: state.providers.searchRunning,
        searchLocationsRunning: state.locations.searchRunning,
        searchSucceeded: state.providers.success || state.locations.success,
        appliedRules,
        appliedRulesLoc,
        specialtyFacet,
        locationSpecialtyFacet: state.locations.specialties,
        providerFilters: {
            usesMyBSWHealthAppliedFilter: { value: usesMyBSWHealthAppliedFilter, display: null },
            usesMyBSWHealth: {
                value: getValue('usesMyBSWHealth', isUrgentCare, usesMyBSWHealthAppliedFilter, provSearchModel),
                display: '', type: 'portal'
            },
            openScheduling: { value: getValue('openScheduling', isUrgentCare, urgentCareBookOnline, provSearchModel), display: 'Book Online' },
            acceptingNewPatient: { value: getValue('acceptingNewPatient', isUrgentCare, false, provSearchModel), display: 'Accepts New Patients' },
            isPrimaryCareAppliedFilter: { value: isPrimaryCareAppliedFilter, display: null },
            isPrimaryCare: { value: getValue('isPrimaryCare', isUrgentCare, isPrimaryCareAppliedFilter, provSearchModel), display: 'Primary Care' },
            isSpecialtyCareAppliedFilter: { value: isSpecialtyCareAppliedFilter, display: null },
            isSpecialtyCare: { value: isSpecialtyCareAppliedFilter || getValue('isSpecialtyCare', isUrgentCare, false, provSearchModel), display: 'Specialty Care' },
            specialties: { value: !isUrgentCare && provSearchModel.specialty ? provSearchModel.specialty.split('|') : [], display: specialtyFacet, type: 'checkboxes' },
            visitType: {
                value: searchParams && searchParams.visitType && searchParams.state && searchParams.state.toLowerCase() === "scheduling"
                    ? searchParams.visitType
                    : getValue('visitType', false, -1, urgentCareModel, provSearchModel), //TODO, need to remove urgentCareModel once we get the confirmation about appliedRules.
                display: state.providers.visitTypes, type: 'radios'
            },
            availability: {
                value: getValue('availability', isUrgentCare, urgentCareAvailability, provSearchModel),
                display: availabilityList, type: 'radios', valueField: 'value', displayField: 'display', defaultValue: -1
            },
            gender: { value: getValue('gender', isUrgentCare, 'Any', provSearchModel), display: genderList, type: 'radios', defaultValue: 'Any' },
            ageGroupsSeen: { value: getValue('ageGroupsSeen', isUrgentCare, '', provSearchModel), display: state.providers.ageGroups, type: 'radios' },
            languages: { value: !isUrgentCare && provSearchModel.language ? provSearchModel.language.split('|') : [], display: state.providers.languages, type: 'checkboxes' },
            distance: {
                value: getValue('distance', urgentCareDistance, urgentCareDistanceValue ? urgentCareDistanceValue : "25", provSearchModel),
                display: null
            },
            sortBy: { value: getValue('sortBy', urgentCareSortByNextAvailableAppointment, 'NextAvailableAppointment', provSearchModel), display: null }
        },
        locationFilters: {
            locationSpecialties: { value: [], display: null },
            locationPerks: {
                value: urgentCarePerksWalkins && urgentCarePerksWalkins.length > 0 ? urgentCarePerksWalkins : locSearchModel.perks ? locSearchModel.perks.split('|') : [],
                display: state.locations.perks, type: 'checkboxes'
            },
            locationServices: {
                value: !isUrgentCare && locSearchModel.services && locSearchModel.services ? locSearchModel.services.split('|') : [],
                display: state.locations.services, type: 'checkboxes'
            },
            locationTypes: {//TODO, need to remove urgentCareModel once we get the confirmation about appliedRules.
                value: urgentCareModel && urgentCareModel.locationType ? urgentCareModel.locationType.split('|') : locSearchModel.locationType ? locSearchModel.locationType.split('|') : [],
                display: state.locations.locationType, type: 'checkboxes'
            },
            //TODO, not sure why it is set to false when is UrgentCareModel.
            locationOpenNow: { value: getValue('openNow', isUrgentCare, false, locSearchModel), display: 'Open Now' },
            locationOpenBefore8: { value: getValue('openBefore8', isUrgentCare, false, locSearchModel), display: 'Open Before 8 AM' },
            locationOpenAfter5: { value: getValue('openAfter5', isUrgentCare, false, locSearchModel), display: 'Open After 5 PM' },
            locationOpenWeekends: { value: getValue('openWeekends', isUrgentCare, false, locSearchModel), display: 'Open Weekends' },
            locationSortBy: { value: getValue('sortBy', isUrgentCare, window.serverData.data.enableFindcareMammogramChanges ? 'NextAvailableAppointment' : 'Distance', locSearchModel), display: null }
        },
        filtersOpen: state.providers.findCareFiltersOpen && ((state.providers.providers && state.providers.providers.length > 0 && ownProps.activeTab === '1') || (state.locations.locations && state.locations.locations.length > 0 && ownProps.activeTab === '2')),
        ...ownProps
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openFilters: (isOpen) => dispatch({ type: types.FIND_CARE_FILTERS_OPEN, isOpen }),
        updateVideoToolTipPreference: () => {
            dispatch({ type: types.UPDATE_VIDEO_VISIT_TOOLTIP_PREFERENCE });
        }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FindCareResults)));